interface CustomerMinimal {
    customerName: string;
    customerLocationName: string;
}

export function formatCustomerName(customer: CustomerMinimal) {
    return `${customer.customerName} - ${customer.customerLocationName}`;
}
